import { Helmet } from 'react-helmet-async';
import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { useProject } from '../../hooks/ProjectContext';
import Iconify from '../../components/iconify';

const SECTIONS = [
  { icon: 'eva:thermometer-outline', title: 'SOC Re-measurement', desc: 'Annual sampling campaign — re-measure soil carbon at monitoring points, assess stock change vs baseline.' },
  { icon: 'eva:flash-outline', title: 'Emissions Monitoring', desc: 'Track fuel, fertilizer, compost inputs — calculate project GHG emissions for the monitoring period.' },
  { icon: 'eva:globe-2-outline', title: 'SDG Assessment', desc: 'Surveys, interviews, observational evidence for selected SDGs (1, 2, 5, 8, 12, 13, 15).' },
  { icon: 'eva:alert-triangle-outline', title: 'Incidents & Deviations', desc: 'Loss events, non-compliance, corrective actions — feeds PDMR Section 3.2.' },
  { icon: 'eva:bar-chart-outline', title: 'ERR Calculation', desc: 'Baseline vs project carbon stocks, leakage, uncertainty, buffer deduction — net VCUs per vintage.' },
  { icon: 'eva:file-text-outline', title: 'Write MR + ERR-MR', desc: 'Monitoring Report and measured ERR — submit PDMR for verification and credit issuance.' },
];

export default function MonitoringPage() {
  const { selectedProject } = useProject();

  return (
    <>
      <Helmet><title>Monitoring | TERRRA</title></Helmet>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Typography variant="h4" gutterBottom>Monitoring</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Annual monitoring cycle for{' '}
          {selectedProject ? <strong>{selectedProject.code}</strong> : 'the selected project'}.
          Each cycle produces a Monitoring Report for VERRA verification.
        </Typography>

        <Stack spacing={2}>
          {SECTIONS.map((s) => (
            <Card key={s.title} variant="outlined">
              <CardContent>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Iconify icon={s.icon} sx={{ width: 32, height: 32, color: 'text.secondary', flexShrink: 0 }} />
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">{s.title}</Typography>
                    <Typography variant="body2" color="text.secondary">{s.desc}</Typography>
                  </Box>
                  <Box sx={{ p: 2, border: '1px dashed', borderColor: 'divider', borderRadius: 1 }}>
                    <Typography variant="caption" color="text.disabled">Coming soon</Typography>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Container>
    </>
  );
}
